import { LogsDrilldownDefaultColumnsLogsDefaultColumnsRecords } from '@grafana/api-clients/rtkq/logsdrilldown/v1beta1';

import { ServiceSceneCustomState } from '../Components/ServiceScene/ServiceScene';
import { DefaultLabelsSettings } from './api';
import { LokiConfig, LokiConfigNotSupported } from './datasourceTypes';

let metadataService: MetadataService;

type LokiConfigState = LokiConfig | undefined | LokiConfigNotSupported;
export function initializeMetadataService(force = false): void {
  if (!metadataService || force) {
    metadataService = new MetadataService();
  }
}

/**
 * Singleton class for sharing state across drilldown routes with common parent scene
 */
export class MetadataService {
  private serviceSceneState: ServiceSceneCustomState | undefined = undefined;
  private lokiConfig: LokiConfigState;
  private defaultColumns: Record<string, LogsDrilldownDefaultColumnsLogsDefaultColumnsRecords> = {};
  private defaultLabels: DefaultLabelsSettings | null = null;

  public getServiceSceneState() {
    return this.serviceSceneState;
  }

  public setPatternsCount(count: number) {
    if (!this.serviceSceneState) {
      this.serviceSceneState = {};
    }

    this.serviceSceneState.patternsCount = count;
  }

  public setLabelsCount(count: number) {
    if (!this.serviceSceneState) {
      this.serviceSceneState = {};
    }

    this.serviceSceneState.labelsCount = count;
  }

  public setEmbedded(embedded: boolean) {
    if (!this.serviceSceneState) {
      this.serviceSceneState = {};
    }
    this.serviceSceneState.embedded = embedded;
  }

  public setFieldsCount(count: number) {
    if (!this.serviceSceneState) {
      this.serviceSceneState = {};
    }

    this.serviceSceneState.fieldsCount = count;
  }

  public setTotalLogsCount(count: number) {
    if (!this.serviceSceneState) {
      this.serviceSceneState = {};
    }

    this.serviceSceneState.totalLogsCount = count;
  }

  public setServiceSceneState(state: ServiceSceneCustomState) {
    this.serviceSceneState = {
      embedded: state.embedded,
      fieldsCount: state.fieldsCount,
      labelsCount: state.labelsCount,
      loading: state.loading,
      logsCount: state.logsCount,
      patternsCount: state.patternsCount,
      totalLogsCount: state.totalLogsCount,
    };
  }

  public setLokiConfig(lokiConfig: LokiConfig | LokiConfigNotSupported) {
    this.lokiConfig = lokiConfig;
  }

  // Don't call this except to init the IndexScene.lokiConfig state!
  public getLokiConfig() {
    return this.lokiConfig;
  }

  public setDefaultColumns(columns: LogsDrilldownDefaultColumnsLogsDefaultColumnsRecords, dsUID: string) {
    this.defaultColumns[dsUID] = columns;
  }

  // Don't call this except to init the indexScene.defaultColumnsRecords state!
  public getDefaultColumns(dsUID: string) {
    return this.defaultColumns[dsUID];
  }

  public setDefaultLabels(defaultLabels: DefaultLabelsSettings | null) {
    this.defaultLabels = defaultLabels;
  }

  public getDefaultLabels() {
    return this.defaultLabels;
  }

  public getDefaultLabelsForDS(dsUID: string) {
    return this.defaultLabels?.[dsUID];
  }

  public getDefaultLabelValuesForDS(dsUID: string, label: string) {
    return this.defaultLabels?.[dsUID]?.find((defaultLabel) => defaultLabel.label === label)?.values;
  }

  public getDefaultLabelForDS(dsUID: string) {
    return this.defaultLabels?.[dsUID]?.[0]?.label;
  }
}

export function getMetadataService(): MetadataService {
  return metadataService;
}
